import { Nullable } from "../base-types";
import { ILinkHelper } from "../link-helper";
import { IApiClient } from "./api-client";
import { IContentHubClient } from "./content-hub-client";
import { IRawClient } from "./raw-client";
import { ISearchClient } from "./search-client";

export interface IWebContentHubClient extends IContentHubClient {
    readonly impersonatedUsername: Nullable<string>;

    readonly api: IApiClient;
    readonly raw: IRawClient;
    readonly linkHelper: ILinkHelper;

    //#region UI Clients
    readonly search: ISearchClient;
    //#endregion
}
